export const sets = [
  {
    code: 'mid',
    name: 'Innistrad: Midnight Hunt',
    path: '/articles/cube-prospective-innistrad-midnight-hunt/',
  },
  {
    code: 'mic',
    name: 'Midnight Hunt Commander',
    path: '/articles/cube-prospective-midnight-hunt-commander/',
  },
  {
    code: 'vow',
    name: 'Innistrad: Crimson Vow',
    path: '/articles/cube-prospective-innistrad-crimson-vow/',
  },
  {
    code: 'voc',
    name: 'Crimson Vow Commander',
    path: '/articles/cube-prospective-crimson-vow-commander/',
  },
  {
    code: 'neo',
    name: 'Kamigawa: Neon Dynasty',
    path: '/articles/cube-prospective-kamigawa-neon-dynasty/',
  },
  {
    code: 'nec',
    name: 'Neon Dynasty Commander',
    path: '/articles/cube-prospective-neon-dynasty-commander/',
  },
  {
    code: 'snc',
    name: 'Streets of New Capenna',
    path: '/articles/cube-prospective-streets-of-new-capenna/',
  },
  {
    code: 'ncc',
    name: 'New Capenna Commander',
    path: '/articles/cube-prospective-new-capenna-commander/',
  },
  {
    code: 'clb',
    name: "Commander Legends: Battle For Baldur's Gate",
    path: '/articles/cube-prospective-commander-legends-battle-for-baldurs-gate/',
  },
]
